module.exports = __webpack_public_path__ + "img/ireland.63d93aa.webp";